import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../pages/index.vue'
import Reservation from '../pages/reservation.vue'
import Notice from '../pages/notice.vue'
import Successful from '../pages/successful.vue'
import Personal from '../pages/personal.vue'
import Location from '../pages/location.vue'
import LocationArea from '../pages/locationArea'
import DepartmentInfo from '../pages/department-info.vue'
import NucleicAcidReport from "../pages/nucleic-acid-report";
import NucleicSuccessful from "../pages/nucleic-successful"

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/location' },
  { path: '/index', name: 'index', component: Index },
  { path: '/reservation', name: 'reservation', component: Reservation },
  { path: '/notice', name: 'notice', component: Notice },
  { path: '/successful', name: 'successful', component: Successful },
  { path: '/personal', name: 'personal', component: Personal },
  { path: '/location', name: 'location', component: Location },
  { path: '/locationArea', name: 'locationArea', component: LocationArea },
  { path: '/department-info', name: 'departmentInfo', component: DepartmentInfo },
  { path: '/nucleic-acid-report', name: 'nucleicAcidReport', component: NucleicAcidReport },
  { path: '/nucleic-successful', name: 'nucleicSuccessful', component: NucleicSuccessful }
]

export default new VueRouter({
  routes
})
